import useBrand from 'hooks/useBrand'

import styles from './RibbonBanner.module.css'

const BigRibbon = ({ children, background }) => (
  <h1 className={styles.ribbon} style={{ background }}>
    {children}
  </h1>
)

const SmallRibbonTop = ({ children, background, textColor }) => (
  <div className={styles.ribbonHolder}>
    <div className={styles.smallRibbonTop} style={{ background, color: textColor }}>
      {children}
    </div>
    <div className={styles.foldLeft} style={{ background }} />
  </div>
)

const SmallRibbonBottom = ({ children, background, textColor }) => (
  <div className={styles.ribbonHolder}>
    <div className={styles.smallRibbonBottom} style={{ background, color: textColor }}>
      {children}
    </div>
    <div className={styles.foldRight} style={{ background }} />
  </div>
)

const RibbonBanner = ({ mainText, topText, bottomText, link }) => {
  let { colors } = useBrand()

  return (
    <div href={link} className={styles.container}>
      {topText && (
        <SmallRibbonTop background={colors.action} textColor={colors.actionText}>
          {topText}
        </SmallRibbonTop>
      )}
      <BigRibbon background={colors.primary}>{mainText || '\u200c'}</BigRibbon>
      {bottomText && (
        <SmallRibbonBottom background={colors.action} textColor={colors.actionText}>
          {bottomText}
        </SmallRibbonBottom>
      )}
    </div>
  )
}

export default RibbonBanner
